import { useState } from 'react';
import { SearchBarContainer, StyledPageContent } from '../SearchLayout/SearchLayout.styled';
import { StyledHeaderContainer } from './RestrictedSearchLayout.styled';
import { IonContent, IonHeader } from '@ionic/react';
import SearchBar from '../../../components/SearchBar';
import { t } from 'i18next';
import TrackItem, { TrackItemDefaultProps } from '../../../components/TrackItem';
import useKeyboard from '../../../utils/hooks/useKeyboard';
import InfiniteGrid from '../../../components/InfiniteGrid';

type RestrictedSearchProps = {
  tracks: TrackItemDefaultProps['track'][];
  onClickTrack: (track: TrackItemDefaultProps['track']) => void;
  onClickTrackVote?: (track: TrackItemDefaultProps['track']) => void;
};

const RestrictedSearchLayout = ({ tracks, onClickTrack, onClickTrackVote }: RestrictedSearchProps) => {
  const { hideKeyboard } = useKeyboard();
  const [limit, setLimit] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');

  const searchResults = tracks
    .filter((track) => [track.title, track.artist.name].join(' ').toLowerCase().includes(searchQuery.toLowerCase()))
    .slice(0, limit);

  return (
    <StyledPageContent>
      <StyledHeaderContainer>
        <IonHeader>
          <SearchBarContainer>
            <SearchBar
              forceOpen
              placeholder={t('searchRestrictedJukeboxPlaceholder')}
              onIonInput={(e) => setSearchQuery(e.target.value ?? '')}
              debounce={250}
            />
          </SearchBarContainer>
        </IonHeader>
      </StyledHeaderContainer>
      <IonContent scrollEvents onIonScrollStart={() => hideKeyboard?.()}>
        {!!searchResults.length && (
          <InfiniteGrid
            loadingElement={<></>}
            onScroll={(e?: Event) => {
              if (limit >= tracks.length) {
                e?.preventDefault();
              }
              setLimit((l) => l + 10);
            }}
          >
            {searchResults.map((track) => (
              <TrackItem
                key={track.id}
                track={track}
                onVoteClick={() => onClickTrackVote?.(track)}
                onClick={() => onClickTrack(track)}
              />
            ))}
          </InfiniteGrid>
        )}
      </IonContent>
    </StyledPageContent>
  );
};

export default RestrictedSearchLayout;
